/**
 * Centralized Session Configuration
 * 
 * This file contains all session-related configuration.
 * Update these values to change session behavior across the application.
 */

export const SESSION_CONFIG = {
  DURATION_HOURS: 24, // 24 hours
  CHECK_INTERVAL: 10000 * 60, // Check every 10 minutes
  WARNING_TIME: 60 * 1000, // Warning at 1 minute before expiry
  EXTEND_ON_ACTIVITY: true,
  ACTIVITY_EXTEND_DURATION: 6 * 60 * 60 * 1000, // 6 hours
  MIN_EXTEND_INTERVAL: 30000, // 30 seconds
};

/**
 * Helper function to calculate session expiration timestamp
 * @returns {number} Timestamp in milliseconds
 */
export const calculateSessionExpiry = () => {
  return Date.now() + SESSION_CONFIG.DURATION_HOURS * 60 * 60 * 1000; // 24 hours
};

/**
 * Helper function to format remaining time
 * @param {number} milliseconds - Time remaining in milliseconds
 * @returns {string} Formatted time string
 */
export const formatRemainingTime = (milliseconds) => {
  if (milliseconds <= 0) return "Expired";
  
  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
};

export default SESSION_CONFIG;